var MES = {};
MES._token = $.jStorage.get("localToken");
MES._page = 1;
MES._pageinfo = null;

MES.init = function () {
  MES.getMessages({}, MES.appendMessages);
  UTL.reachBottom(function () {
    if (!MES._pageinfo) return;
    if (MES._page >= MES._pageinfo.pages) {
      //  $('.bottom-line').show()
      if (MES._pageinfo.totalCount > 0) {
        $(".bottom-line").slideDown();
      }
      //没有更多
      return;
    }
    MES._page++;
    MES.getMessages(MES.appendMessages);
  });
};

MES.getMessages = function (query, cb) {
  showLoadingGif();
  $.ajax({
    url: v1url + "pay-project/pc-messages",
    type: "GET",
    data: { page: MES._page },
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: MES._token
    },
    dataType: "json",
    success: function (data) {
      console.log(data)
      if (data.code == 1000) {
        MES._pageinfo = data.data._pageinfo;
        if (MES._pageinfo.totalCount == 0) {
          $('#emptyMessageDom').show();
          $('.bottom-line').hide();
        }
        cb && cb(data);
      } else if (data.code == -1) {
        UTL.showPCLoginForm();
      } else {
        toastr.error(data.message);
      }
      closeLoadingGif();
    },
    error: function () { }
  });
};

MES.appendMessages = function (data) {
  var days = data.data.items;
  var i = 0,
    len = days.length;
  var newdayshtml = "";
  for (; i < len; i++) {
    var day = days[i],
      p_html = "";
    var i2 = 0,
      len2 = day.items.length;
    for (; i2 < len2; i2++) {
      var proj = day.items[i2];
      p_html += ` <li class="item clearfix">
                <div class="logo" style="background-image: url(${proj.logo_url
          ? `${proj.logo_url}`
          : "../../imgs/pay/common/bird.png"});"></div>
                <div>
                <p>
                <span class="name"> ${proj.name} </span>
                ${proj.is_publish == 1
          ? ' <span class="report">优选项目</span>'
          : ""}
                </p>
                <p id="seeMore" data-name=${proj.name}><span> ${proj.message} </span><a target="_blank" href="projectdetail/${proj.project_id}?from=dynamics_project">查看更多</a></p>
                </div>
                </li>`;
    }
    var $exist_day = $("#days").find("[data-day=" + day.time + "]");

    if ($exist_day.length > 0) {
      $exist_day.find("ul").append(p_html);
      continue;
    }

    var timeArr = day.time.split("-");
    newdayshtml +=
      '<div class="day clearfix" data-day="' +
      day.time +
      '">' +
      '<div class="date">' +
      timeArr[1] +
      "月" +
      timeArr[2] +
      "日</div>" +
      "<ul>" +
      p_html +
      "</ul>" +
      "</div>" +
      "</div>";
  }
  // console.log(newdayshtml)
  $("#days").append(newdayshtml);
};
